import classNames from 'classnames'
import React from 'react'
import { Link } from 'react-router-dom'
import { getIconSetName, ODIcon } from '../../icons'
import { isLinkExternal } from '../../utils'
var LinkContents = function (_a) {
  var icon = _a.icon,
    text = _a.text
  return React.createElement(
    React.Fragment,
    null,
    icon &&
      React.createElement(
        'span',
        { className: classNames('od-linkable-ico-wrapper', getIconSetName(icon)) },
        React.createElement(ODIcon, {
          icon: icon,
          style: { paddingRight: 12 },
          className: classNames('od-linkable', getIconSetName(icon)),
        })
      ),
    text
  )
}
var ODGlobalFactory = /** @class */ (function () {
  function ODGlobalFactory(def) {
    this.def = def
  }
  ODGlobalFactory.prototype.renderLinkable = function (key, linkable, className) {
    var link = linkable.link,
      openNewWindow = linkable.openNewWindow,
      text = linkable.text,
      icon = linkable.icon
    if (isLinkExternal(link)) {
      return React.createElement(
        'a',
        {
          href: link,
          className: className,
          target: openNewWindow ? '_blank' : undefined,
          rel: openNewWindow ? 'noopener noreferrer' : undefined,
        },
        React.createElement(LinkContents, { icon: icon, text: text })
      )
    }
    return React.createElement(
      Link,
      { key: key, to: link },
      React.createElement(LinkContents, { icon: icon, text: text })
    )
  }
  return ODGlobalFactory
})()
export { ODGlobalFactory }
//# sourceMappingURL=ODGlobalFactory.js.map
